import { Component, OnInit } from '@angular/core';
import { MetricRankingsService } from 'src/app/services/metric-rankings.service';
import { RankingsService } from 'src/app/services/rankings.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-seasonal-ranking',
  templateUrl: './seasonal-ranking.component.html',
  styleUrls: ['./seasonal-ranking.component.scss']
})
export class SeasonalRankingComponent implements OnInit {

    private unsubscribe: Subject<any> = new Subject();
    updatingCondition: boolean;
    private selectedCondition: string = "Enter Ranking Name";
    private conditionSelected: boolean = false;

  constructor(
    public rankingsService: RankingsService,
    public metricRankingsService: MetricRankingsService
  ) {}

  ngOnInit() {
    this.rankingsService.getRankings();
  }

  ngOnDestroy() {
    this.rankingsService.setRankings(null);
  }

  toggleUpdating() {
      this.updatingCondition = !this.updatingCondition;
  }

  updateSelection(selection) {
      this.selectedCondition = selection;
      if (selection.length > 0) {
          this.conditionSelected = true;
      }
      else {
          this.conditionSelected = false;
      }
  }

  cancel() {
      this.toggleUpdating();
      this.selectedCondition = "Enter Ranking Name";
      this.conditionSelected = false;
  }

}
